// Module
var code = "<ticket-status status=success title=\"{{ 'app.ticket.status.' + vm.stateName + '.' + vm.ticket.aggregatedStatus + '.success.title' }}\" body=\"{{ 'app.ticket.status.' + vm.stateName + '.' + vm.ticket.aggregatedStatus + (vm.ticket.email ? '.online' : '') + '.success.body' }}\" cta=vm.navigateToActive() cta-title=app.tickets.navigateToActive icon=fa-check> </ticket-status> ";
// Exports
var _module_exports = code;;
var path = 'app/components/ticket/partials/ticket.statusCompleted.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;